<template>
  <div class="tab-content">

    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- budget -->
      <el-tab-pane :disabled="!engagementPermission.viewATBudget" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_at_budget')" name="budget">

        <el-tabs>
          <!-- <el-tab-pane :label="$t('e_tab_at_budget_time')" name="budgetTimeEngagement">
            Current Service Under Development
          </el-tab-pane> -->

          <el-tab-pane :disabled="!engagementPermission.createATBudgetMaterial" :label="$t('e_tab_at_budget_material')" name="budgetMaterialEngagement">
            Current Service Under Development
          </el-tab-pane>

          <el-tab-pane :disabled="!engagementPermission.viewATBudgetSummary" :label="$t('e_tab_at_budget_summary')" name="budgetSummaryEngagement">
            Current Service Under Development
          </el-tab-pane>

          <el-tab-pane :disabled="!engagementPermission.viewATBudgetAnalysis" :label="$t('e_tab_at_budget_analysis')" name="budgetAnalysisEngagement">
            Current Service Under Development
          </el-tab-pane>
        </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskATBudget" v-else :label="$t('e_tab_at_budget')" name="budget">

        <el-tabs>
          <el-tab-pane :disabled="!engagementPermission.createTaskATBudgetTime" :label="$t('e_tab_at_budget_time')" name="budgetTime">
            Current Service Under Development
          </el-tab-pane>

          <el-tab-pane :disabled="!engagementPermission.createTaskATBudgetMaterial" :label="$t('e_tab_at_budget_material')" name="budgetMaterial">
            Current Service Under Development
          </el-tab-pane>

          <el-tab-pane :disabled="!engagementPermission.viewTaskATBudgetSummary" :label="$t('e_tab_at_budget_summary')" name="budgetSummary">
            Current Service Under Development
          </el-tab-pane>

          <el-tab-pane :disabled="!engagementPermission.viewTaskATBudgetAnalysis" :label="$t('e_tab_at_budget_analysis')" name="budgetAnalysis">
            Current Service Under Development
          </el-tab-pane>
        </el-tabs>

      </el-tab-pane>

      <!-- cash advances -->
      <el-tab-pane :disabled="!engagementPermission.viewATCashAdvances" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_at_cashAdvances')" name="cashAdvancesProject">
          Current Service Under Development
          <!-- (Cash Advances project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskATCashAdvances" v-else :label="$t('e_tab_at_cashAdvances')" name="cashAdvancesTask">
          Current Service Under Development
          <!-- (Cash Advances) -->
      </el-tab-pane>

      <!-- expenses -->
      <el-tab-pane :disabled="!engagementPermission.viewATExpenses" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_at_expenses')" name="expensesProject">
          Current Service Under Development
          <!-- (Expenses project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskATExpenses" v-else :label="$t('e_tab_at_expenses')" name="expensesTask">
          Current Service Under Development
          <!-- (Expenses) -->
      </el-tab-pane>

      <!-- receive payment -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Receive Payment" name="receivePaymentProject">
          Current Service Under Development
          (Receive Payment project)
      </el-tab-pane>
      <el-tab-pane v-else label="Receive Payment" name="receivePaymentTask">
          Current Service Under Development
          (Receive Payment)
      </el-tab-pane> -->

      <!-- pay vendors -->
      <el-tab-pane :disabled="!engagementPermission.viewATPayVendors" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_at_payVendors')" name="payVendorsProject">
          Current Service Under Development
          <!-- (Pay Vendors project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskATPayVendors" v-else :label="$t('e_tab_at_payVendors')" name="payVendorsTask">
          Current Service Under Development
          <!-- (Pay Vendors) -->
      </el-tab-pane>

    </el-tabs>

    <!-- bookmark -->
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div v-if="selectedRow.type === 'Engagement'">-->
<!--        <div v-if="bookmarkListEngagement.accountTHINK" @click="changeBookMarkEngagement(bookmarkListEngagement.accountTHINK, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMarkEngagement(bookmarkListEngagement.accountTHINK, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <div v-if="bookmarkList.accountTHINK" @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  // estimate
  import estimateTab from '@/components/Projects/accountTHINK/estimate/estimateTab.vue'

  export default {
    components: {
      estimateTab,
    },
    props: [
      'isEngagement',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListEngagement',
      'engagementPermission'
    ],
    data() {
      return {
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // cash advances
        if(tab.label === "Cash Advances" && tab.name == "cashAdvancesProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Cash Advances" && tab.name == "cashAdvancesTask" && !this.isEngagement){
          // dispatch
        }

        // expenses
        if(tab.label === "Expenses" && tab.name == "expensesProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Expenses" && tab.name == "expensesTask" && !this.isEngagement){
          // dispatch
        }

        // receive payment
        if(tab.label === "Receive Payment" && tab.name == "receivePaymentProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Receive Payment" && tab.name == "receivePaymentTask" && !this.isEngagement){
          // dispatch
        }

        // pay vendors
        if(tab.label === "Pay Vendors" && tab.name == "payVendorsProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Pay Vendors" && tab.name == "payVendorsTask" && !this.isEngagement){
          // dispatch
        }

        // purchase
        if(tab.label === "Purchase" && tab.name == "purchaseProject" && this.isEngagement){
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
          loader.hide()
          // this.$refs.purchaseProjectTable.handleClick(tab, event, projectTaskId)
        }
        if(tab.label === "Purchase" && tab.name == "purchaseTask" && !this.isEngagement){
          // dispatch
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
          loader.hide()
          // this.$refs.purchaseTaskTable.handleClick(tab, event, projectTaskId)
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, engagementId, taskId){
        let data = this.bookmarkList
        data.accountTHINK = !this.bookmarkList.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${engagementId}&engagementTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      changeBookMarkEngagement(state, companyId, engagementId, taskId){
        let data = this.bookmarkListEngagement
        data.accountTHINK = !this.bookmarkListEngagement.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setEngagement?companyId=${companyId}&engagementId=${engagementId}`, data)
          .then(response => {
            if (this.bookmarkListEngagement.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
